// pricing.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import './pricing.css';
import firebase from '../../firebase-config';
import { trackEvent } from '../../config/googleAnalytics';

const Pricing = () => {
  const navigate = useNavigate();

  const plans = [
    {
      type: 'weekly',
      duration: '1 Week',
      price: 99.99,
      popular: false
    },
    {
      type: 'monthly',
      duration: '1 Month',
      price: 249.99,
      popular: true
    },
    {
      type: 'yearly',
      duration: '1 Year',
      price: 1999.99,
      popular: false,
      savings: '33% savings'
    }
  ];

  const handleSubscription = async (planType) => {
    try {
      const selectedPlan = plans.find(plan => plan.type === planType);
      
      // Track plan selection in Google Analytics
      trackEvent(
        'Subscription', 
        'Plan Selected', 
        planType, 
        selectedPlan.price
      );
      
      // Store selected plan details in localStorage
      const planDetails = {
        type: planType,
        price: selectedPlan.price,
        currency: 'ZAR',
        duration: selectedPlan.duration
      };
      localStorage.setItem('selectedPlan', JSON.stringify(planDetails));

      // Check if user is already logged in
      const user = firebase.auth.currentUser;
      if (user) {
        // If logged in, go directly to checkout
        navigate('/checkout');
      } else {
        // If not logged in, go to login page
        navigate('/login');
      }
    } catch (error) {
      console.error('Error:', error);
      alert('Something went wrong. Please try again.');
    }
  };

  const handleLoginClick = () => {
    // Track login click from pricing page
    trackEvent('User', 'Login Click', 'From Pricing Page');
    navigate('/login');
  };

  return (
    <div className="pricing-page-container">
      <div className="pricing-page-title">Choose Your Plan</div>
      <div className="pricing-page-currency-notice">
        Prices shown in South African Rand (ZAR)
      </div>
      <div className="pricing-page-cards">
        {plans.map((plan) => (
          <div key={plan.type} className={`pricing-page-card ${plan.popular ? 'pricing-page-popular-card' : ''}`}>
            {plan.popular && <div className="pricing-page-most-popular">Best Value</div>}
            <div className="pricing-page-card-header">{plan.duration}</div>
            <div className="pricing-page-card-price">
              R{plan.price.toFixed(2)}
              <span>/{plan.type === 'yearly' ? 'year' : plan.type === 'monthly' ? 'month' : 'week'}</span>
            </div>
            {plan.savings && (
              <div className="pricing-page-savings">{plan.savings}</div>
            )}
            <p className="pricing-page-card-description">Full Access Plan</p>
            <ul className="pricing-page-card-features">
              <li>Unlimited AI conversations</li>
              <li>24/7 AI availability</li>
              <li>Message analysis</li>
              <li>Conversation starters</li>
              <li>Response optimization</li>
              <li>Personality insights</li>
              <li>Priority support</li>
            </ul>
            <button 
              className="pricing-page-card-button"
              onClick={() => handleSubscription(plan.type)}
            >
              Get Started
            </button>
          </div>
        ))}
      </div>
      <div className="existing-user-section">
        <p>Already have an active membership?</p>
        <button className="login-button" onClick={handleLoginClick}>
          Login Here
        </button>
      </div>
    </div>
  );
}

export default Pricing;
